import { Component, Vue, PropSync, Watch, Emit } from 'vue-property-decorator';
import { ConfigurationFilterField, IConfigurationFilterField } from '@/models/filter/ConfigurationFilterField';
import { FieldTypeEnum } from '@/enums/FieldTypeEnums';
import { Helpers } from '@/helpers/Helpers';
import { ApiIdentifers } from '@/config/index';
import { LoggerService } from '@/utils';

import FilterFieldComponent, { IFilterFielddEvent } from '@/components/filter/filterFieldNew/FilterField';
import FilterField from '@/components/filter/filterFieldNew/FilterField.vue';

@Component({
    components: {
        FilterField,
    },
    name: 'FilterSectionFieldsComponent',
})
export default class FilterSectionFieldsComponent extends Vue {
    @PropSync('fields', { type: Array }) public syncedFields!: ConfigurationFilterField[];
    @PropSync('sectionRefName', { type: String }) public syncedSectionRefName!: string;
    @PropSync('openAll', { type: Boolean, default: false }) public syncedOpenAll!: boolean;

    public subFieldsIndex: number = 0;
    public lastCheckedFieldsIndex: number = 0;
    public openSections: number[] = [];

    public dialog: boolean = false;
    public dialogHeadline: string = '';
    public dialogText: string = '';
    public dialogOk: string = '';

    private normalFieldCount: number = 0;
    private allSectionsOpened = false;


    public mounted() {
        this.updateNormalFieldCount();
        if (this.syncedOpenAll === true && this.allSectionsOpened === false) {
            this.openAllSections(!this.allSectionsOpened);
        }
    }

    public updated() {
        this.updateNormalFieldCount();
    }

    @Watch('syncedFields', { deep: true })
    public onSyncedFieldChanged(newValue: ConfigurationFilterField[]) {
        // LoggerService.LogDebug(`onSyncedFieldChanged (${this.syncedSectionRefName}): `, newValue);

        if (this.syncedOpenAll === true) {
            this.openAllSections(!this.allSectionsOpened);
        }
    }

    @Emit()
    public fieldEvent(event: IFilterFielddEvent): IFilterFielddEvent {
        return event;
    }

    public hasSubFields(field: ConfigurationFilterField): boolean {
        let hasSubFields = false;
        if (field.type === FieldTypeEnum.SUBFIELD) {
            hasSubFields = true;
        }

        return hasSubFields;
    }

    public isSubField(field: ConfigurationFilterField): boolean {
        return field.type === FieldTypeEnum.SUBFIELD;
    }

    public isActionField(field: ConfigurationFilterField): boolean {
        return field.type === FieldTypeEnum.ACTION_SUBFIELD;
    }

    public onDeleteSubSection(index: number) {
        LoggerService.LogDebug(`onDeleteSubSection ${index} clicked`);

        this.subFieldsIndex += index === 0 ? 1 : -1;
        this.syncedFields.splice(index, 1);

        const openIndex = this.openSections.findIndex((x) => x === index);
        if (openIndex > -1) {
            this.openSections.splice(openIndex, 1);
        }
        this.openAllSections(true);
    }


    public getSetValuesCounter(field: ConfigurationFilterField): number {
        let setValueCount = 0;
        if (field.fields != null) {
            for (const subField of field.fields) {
                setValueCount += subField.getSetValuesCounter();
            }
        } else {
            setValueCount += field.getSetValuesCounter();
        }
        return setValueCount;
    }

    public onFieldEvent(event: IFilterFielddEvent) {
        this.fieldEvent(event);
    }

    public onUnitChanged(inField: IConfigurationFilterField) {
        const valueField = this.syncedFields.find((f: IConfigurationFilterField) => f.unit === inField.identifier);
    }

    public onSubFieldClick(subIndex: number) {
        LoggerService.LogDebug(`onSubFieldClick ${subIndex} clicked`);
        /**
         * since only fields with subfields create a new expansion-panel
         * we need to subtract all normal fields from index to get the
         * correct index for the expansion-panels to open
         */
        const subFieldIndex = (subIndex - this.normalFieldCount);
        const openIndex = this.openSections.findIndex((x) => x === subFieldIndex);
        this.lastCheckedFieldsIndex = subIndex;

        /**
         * TODO: check subindex in samples, seems tzo be broken with normalFieldCount
         */

        if (openIndex > -1) {
            this.openSections.splice(openIndex, 1);
        } else {
            this.subFieldsIndex = subFieldIndex;
            this.openSections.push(this.subFieldsIndex);
        }
    }

    public getRefName(name: string, prefix: string): string {
        return Helpers.getReferenceName(name, `${this.syncedSectionRefName}-${prefix}`);
    }

    protected openAllSections(openAll: boolean) {
        LoggerService.LogDebug(`openAllSections: ${this.syncedSectionRefName}`);
        let i = 0;
        if (this.syncedFields != null
            && this.syncedFields.length > 0
            && openAll) {
            this.openSections = Array.from(new Array(this.syncedFields.length - this.normalFieldCount), () => i++);
            this.allSectionsOpened = true;
        }
    }

    private getSectionFieldsRef(sectionRefName: string): FilterSectionFieldsComponent {
        return Helpers.getReference<FilterSectionFieldsComponent>(this.$refs, sectionRefName);
    }

    private getFieldRef(sectionRefName: string): FilterFieldComponent {
        return Helpers.getReference<FilterFieldComponent>(this.$refs, sectionRefName);
    }

    private updateNormalFieldCount() {
        // number of fields without subfields
        this.normalFieldCount = this.syncedFields
            .filter((f) => f.type !== FieldTypeEnum.SUBFIELD && f.type !== FieldTypeEnum.ACTION_SUBFIELD).length;
    }
}
